import { Component, OnInit } from '@angular/core';
import { AdminValidationService } from 'src/app/gamification/command-center/services/admin-validation.service';

@Component({
    selector: 'cv-admin-budget',
    templateUrl: './cv-admin-budget.component.html',
    styleUrls: ['./cv-admin-budget.component.scss']
})
export class CvAdminBudgetComponent implements OnInit {
    private isBudgetMeterLoading = false;
    private isBudgetSetupLoading = false;
    private isBudgetNotificationsLoading = false;
    private isBudgetHistoryLoading = false;

    constructor(
        
        private adminValidationService: AdminValidationService
    ) { }

    ngOnInit(): void {
        this.adminValidationService.isLoadingSavingProcess = true;

    }

    onLoadingStateChange(isLoading: boolean, budgetElement: number) {
        switch (budgetElement) {
            case 1:
                this.isBudgetMeterLoading = isLoading;
                break;
            case 2:
                this.isBudgetSetupLoading = isLoading;
                break;
            case 3:
                this.isBudgetNotificationsLoading = isLoading;
                break;
            case 4:
                this.isBudgetHistoryLoading = isLoading;
                break;
        }
        if (!this.isBudgetMeterLoading && !this.isBudgetSetupLoading && !this.isBudgetNotificationsLoading && !this.isBudgetHistoryLoading) {
            this.adminValidationService.isLoadingSavingProcess = false;
        }

    }
}